


































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import VueToExcel from 'vue-json-excel';
import RuleUsage from '@/domain/scripts/entity/rule-usage.entity';

@Component({
  components: { VueToExcel },
})
export default class RuleUsageModal extends Vue {
  @Prop() showModal!: boolean;

  @Prop({ default: () => [] }) usageItems!: RuleUsage[];

  @Prop({ default: '' }) ruleName!: string;

  @Prop({ default: null }) ruleVersion!: number | null;

  csvLabel = {
    Cálculo: 'ruleName',
    'Versão do Cálculo': 'ruleVersion',
    'Unidade de Negócio': 'businessUnitName',
    'N. Contrato': 'contractExternalId',
    Item: 'itemNumber',
    Descrição: 'itemName',
  }

  get exportData() {
    return this.usageItems.map((item: RuleUsage) => ({
      ...item,
      ruleName: this.ruleName,
      ruleVersion: this.ruleVersion,
    }));
  }

  get modalState(): boolean {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  get groupedByBusinessUnit() {
    const businessUnits: { [key: string]: any } = {};

    this.usageItems.forEach((item: RuleUsage) => {
      if (!businessUnits[item.businessUnitId]) {
        businessUnits[item.businessUnitId] = {
          businessUnitId: item.businessUnitId,
          businessUnitName: item.businessUnitName,
          items: [],
          contractsByContractId: {},
        };
      }
      const group = businessUnits[item.businessUnitId];
      group.items.push(item);

      if (!group.contractsByContractId[item.contractId]) {
        group.contractsByContractId[item.contractId] = {
          contractId: item.contractId,
          contractNumber: item.contractNumber,
          contractExternalId: item.contractExternalId,
          items: [],
        };
      }
      group.contractsByContractId[item.contractId].items.push(item);
    });

    return Object.values(businessUnits).map((group: any) => ({
      businessUnitId: group.businessUnitId,
      businessUnitName: group.businessUnitName,
      items: group.items,
      contracts: Object.values(group.contractsByContractId),
    }));
  }
}
